
import { mapGetters, mapMutations } from 'vuex'
import * as ov from '@/constants/constants'

export default {
    head() {
        return {
            title: this.narrator.metatitle ? this.narrator.metatitle : this.narrator.firstname + ' ' + this.narrator.lastname,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.narrator.metadesc,
                }
            ],
        }
    },

    data() {
        return {
            narrator: null,
        };
    },

    asyncData(context) {
        return context.$axios
            .get('/narrators/' + context.params.narrator)
            .then((res) => {
                if (res.data.narrator.on_moderate || res.data.narrator.disabled) {
                    context.error({ statusCode: 404 })
                }

                return {
                    narrator: res.data.narrator,
                }
            })
            .catch((e) => {
                context.error({ statusCode: 404 })
            })

    },

    computed: {
        ...mapGetters(['isAuthenticated', 'loggedInUser']),
        ov() {
            return ov
        },
        narratorImage() {
            return this.narrator.image ? this.narrator.image : ov.DEFAULT_IMAGE
        },

        long_c_perc() {
            return 100 - Math.ceil((+this.narrator.prices.long_c_5p / +this.narrator.prices.long_c_1p) * 100)
        },

        notNarrator() {
            return !this.isAuthenticated || (this.isAuthenticated && (this.loggedInUser.role == 'client'))
        },

        selectedDays() {
            var arr = Object.values(this.narrator.timetable)
            delete arr[0]
            return (arr.findIndex(item => item) + 1)
        },
    },

    methods: {
        toOrder(genre, subgenre = null) {
            this.$store.commit('setOrderGenre', genre)
            this.$store.dispatch('setOrderNarrator', this.narrator.id)
        },

        openReviews() {
            this.$root.$emit('open-modal', { modal: 'reviews', id: this.narrator.id })
        },

        selectNarrator() {
            this.$store.dispatch('setOrderNarrator', this.narrator.id)
        },
    },

    mounted() {
        window.refreshPage()
    },

}
